export default __webpack_public_path__ + "static/media/htw5.76e5c58a.svg";